import React, { FC } from 'react'
import { ArtistRating } from '../../../../models/ArtistFormNotificationsModels/ArtistFormNotifications.model'
import Evaluation from '../Evaluation/Evaluation'
import './ArtistEvaluationsBlock.style.sass'


type Props = {
  artistRating: ArtistRating;
  genre?: string;
}
const ArtistEvaluationsBlock: FC<Props> = ({artistRating, genre}) => {
  const {music, emotional, concertActivities, total} = artistRating
  const qualityMaxValue = 10
  const emotionamMaxValue = 10
  const experienceMaxValue = 5

  const totalMaxValue = qualityMaxValue + emotionamMaxValue + experienceMaxValue

  const emotionalTitle = genre === 'dance'
    ? 'Уровень эмоционального отклика члена экспертного совета на представленные произведения'
    : 'Уникальность, актуальность и целостность концепции исполнителя'

  return (
    <div className="evaluations">
      <Evaluation
        title={'качество музыкальных произведений'}
        evaluationMaxValue={qualityMaxValue}
        evaluationValue={music}
      />
      <Evaluation
        title={emotionalTitle}
        evaluationMaxValue={emotionamMaxValue}
        evaluationValue={emotional}
      />
      <Evaluation
        title={'Опыт концертной деятельности'}
        evaluationMaxValue={experienceMaxValue}
        evaluationValue={concertActivities}
      />
      <Evaluation
        title={'Ваш средний балл'}
        evaluationMaxValue={totalMaxValue}
        evaluationValue={total}
        isTotal
      />
    </div>
  )
}

export default ArtistEvaluationsBlock
